module.exports = __webpack_public_path__ + "img/flower2.3732f52a.png";